import { MarketingTemplate } from "@modootoday/ui-widgets/templates";
import { useAuth } from "@/shared/hooks/use-auth";
import {
  AboutSection,
  CtaSection,
  DomainsSection,
  FeaturesSection,
  HeroSection,
  LandingFooter,
  LandingNav,
  PricingSection,
  WhySection,
} from "./sections";

export function LandingPage() {
  const { isAuthenticated } = useAuth();

  return (
    <MarketingTemplate
      nav={<LandingNav isAuthenticated={isAuthenticated} />}
      footer={<LandingFooter />}
    >
      <HeroSection isAuthenticated={isAuthenticated} />
      <DomainsSection />
      <FeaturesSection />
      <WhySection />
      <AboutSection />
      <PricingSection />
      <CtaSection isAuthenticated={isAuthenticated} />
    </MarketingTemplate>
  );
}
